import { useCallback } from 'react';

import { useLocale } from '@tanium/react-locale-context';

import { standardNumberFormatter } from '../formatters/standardNumberFormatter';
import { NumberCoercible } from '../utils/NumberCoercible';
import { NumberFormatterType } from '../utils/NumberFormatterType';

/**
 * Hook that returns a locale aware standard number formatter (long format rounded to the nearest tenth).
 */
export const useLocalizedStandardNumberFormatter = (): NumberFormatterType => {
  const locale = useLocale();
  return useCallback((value: NumberCoercible) => standardNumberFormatter(value, locale), [locale]);
};
